module.exports = __webpack_public_path__ + "images/backgrounds/fall/large.a42f50fe10ff082519a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/fall/large.jpg
// module id = vo7M
// module chunks = 13